import { render, staticRenderFns } from "./ForgotPasswordConfirm.vue?vue&type=template&id=68c44838&scoped=true&"
import script from "./ForgotPasswordConfirm.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordConfirm.vue?vue&type=style&index=0&id=68c44838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c44838",
  null
  
)

export default component.exports